import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '../../service/message.service';
import { TableElement } from '../../table/table.element';
import { SelectCondition } from '../selectDialog/model/selectCondition';
import { SelectDialogComponent } from '../selectDialog/selectDialog.component';

@Component({
	selector: 'app-select-tenant-dialog',
	templateUrl: './selectTenantDialog.component.html',
	styleUrls: ['./selectTenantDialog.component.scss']
})
export class SelectTenantDialogComponent extends SelectDialogComponent implements OnInit, AfterViewInit {

	selectedTenant: any;
	tenantEndPoint: string;

	constructor(
		messageService: MessageService,
		dialogRef: MatDialogRef<SelectDialogComponent>,
		@Inject(MAT_DIALOG_DATA) data: SelectCondition,
		translateService: TranslateService
	) {
		super(
			messageService,
			dialogRef,
			data,
			translateService
		);
		this.tenantEndPoint = data.extended.tenantEndPoint;
	}

	ngOnInit() {
	}

	ngAfterViewInit() {
	}

	onTenantSelected(tenant: any) {
		this.selectedTenant = tenant;
	}

	protected handleSelect(result: any[]): TableElement[] {
		if (!this.selectedTenant) {
			this.translateService.get('common.dialog.select-dialog.alert.no-tenant-selected').subscribe((message: string) => {
				alert(message);
			});
			return null;
		} else {
			return super.handleSelect(result);
		}
	}

	doSelect(selectedElements: any[]) {
		const result = this.handleSelect(selectedElements);

		if (result) {
			this.dialogRef.close({
				result: true,
				tenantId: this.selectedTenant.id,
				data: result
			});
		}
	}
}
